import React from 'react';
import './Card.scss';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'elevated' | 'bordered';
  padding?: 'none' | 'small' | 'medium' | 'large';
  animate?: boolean;
  animateDelay?: number;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  variant = 'default',
  padding = 'medium',
  animate = false,
  animateDelay = 0
}) => {
  const cardClasses = [
    'card',
    `card--${variant}`,
    `card--padding-${padding}`,
    animate && 'animate-fadeUp',
    className
  ].filter(Boolean).join(' ');

  const style = animate && animateDelay ? { animationDelay: `${animateDelay}s` } : {};

  return (
    <div className={cardClasses} style={style}>
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({
  children,
  action,
  className = ''
}) => {
  return (
    <div className={`card-header ${className}`}>
      <div className="card-header__content">
        {children}
      </div>
      {action && (
        <div className="card-header__action">
          {action}
        </div>
      )}
    </div>
  );
};

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({
  children,
  className = ''
}) => {
  return (
    <h3 className={`card-title ${className}`}>
      {children}
    </h3>
  );
};

interface CardBodyProps {
  children: React.ReactNode;
  className?: string;
}

export const CardBody: React.FC<CardBodyProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={`card-body ${className}`}>
      {children}
    </div>
  );
};

export default Card;